<mat-drawer-container class="sidebar-container" autosize>
    <mat-drawer opened class="sidebar-nav" [class.mobile]="isMobile" [mode]="'side'" disableClose>
        <div *ngFor="let group of menu">
            <span class="title" *ngIf="displayTitle">
                {{ group.label }}
            </span>
            <mat-nav-list class="nav-list">
                <ng-container *ngFor="let item of group.items">
                    <a
                        mat-list-item
                        role="listitem"
                        *permissionLevel="item.permissions"
                        [routerLink]="item.route"
                        [class.active]="item.active"
                    >
                        <mat-icon matListItemIcon class="nav-list-icon">{{ item.icon }}</mat-icon>
                        <span matListItemTitle *ngIf="!isSidenavCollapsed" class="item-title">
                            <span class="capitalize">{{ item.label }}</span>
                            <app-feature-discovery
                                [featureFlagKey]="featureFlagKey"
                                [customTarget]="{
            feature: item.route,
        }"
                            ></app-feature-discovery>
                        </span>

                        <span
                            matListItemMeta
                            class="nav-list-icon"
                            *ngIf="!isSidenavCollapsed && item.active"
                        >
                            <mat-icon>keyboard_arrow_right</mat-icon></span
                        >
                    </a>
                </ng-container>
            </mat-nav-list>
        </div>

        <mat-nav-list class="nav-list" *appDeviceRenderer="deviceTypes.mobile">
            <a mat-list-item role="listitem" (click)="toggleSidenav()">
                <mat-icon matListItemIcon class="nav-list-icon">
                    {{ isSidenavCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}
                </mat-icon>
            </a>
        </mat-nav-list>

        <ng-container *appDeviceRenderer="deviceTypes.desktop">
            <ng-content select="[customContent]"></ng-content>
        </ng-container>
    </mat-drawer>
    <mat-drawer-content>
        <ng-content></ng-content>
    </mat-drawer-content>
</mat-drawer-container>
